module.exports = __webpack_public_path__ + "media/תיק.d51d9a93.mp3";